import { Injectable } from '@angular/core';
import { Headers, Http, Request, Response, RequestOptionsArgs, ResponseContentType, RequestMethod } from '@angular/http';
import { HttpRequest, HttpParams, HttpClient, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Store } from '@ngrx/store';

import * as fromRoot from '../store/reducers';
import { AppUiActions } from '../store/actions';
import { AuthService } from './auth.service';
import { LoggerService } from './logger.service';
import * as ErrorMessage from '../errors/constants';

declare var _paragonConfig: PgRendererDto.ParagonAppConfig;

@Injectable()
export class BaseHttpService {
    protected testContentServerApiUrl: string = _paragonConfig.testContentServerApiUrl;
    protected testServerApiUrl: string = _paragonConfig.testServerApiUrl;

    constructor(
        protected http: Http,
        protected httpClient: HttpClient,
        protected store: Store<fromRoot.State>,
        protected loggerService: LoggerService,
        protected authService: AuthService
    ) {
    }

    protected request(options: RequestOptionsArgs, isFormData: boolean = false): Observable<any> {
        return this.createRequest(options, isFormData)
            .map(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            })
            .catch(this.handleError);
    }

    protected requestForBlob(options: RequestOptionsArgs): Observable<any> {
        options.responseType = ResponseContentType.Blob;
        return this.createRequest(options, false)
            .map(response => {
                try {
                    return response.blob();
                } catch (error) {
                    console.log(error);
                    return null;
                }
            })
            .catch(this.handleError);
    }

    protected requestForText(options: RequestOptionsArgs): Observable<any> {
        return this.createRequest(options, false)
            .map(response => {
                try {
                    return response.text();
                } catch (error) {
                    console.log(error);
                    return null;
                }
            })
            .catch(this.handleError);
    }

    protected requestWithProgress(url: string, method: string, body: any = {}): Observable<HttpEvent<any>> {
        const req = new HttpRequest(method, url, body, {
            headers: this.getHttpHeaders(),
            reportProgress: true
        });
        return this.httpClient.request(req);
    }

    private createRequest(options: RequestOptionsArgs, isFormData: boolean): Observable<Response> {
        this.injectCustomHeaders(options, isFormData);
        return this.http.request(new Request(options as any));
    }

    private injectCustomHeaders(options: RequestOptionsArgs, isFormData: boolean) {
        if (options) {
            if (!options.headers) {
                options.headers = new Headers();
            }

            const accessToken = this.authService.getAccessToken();
            if (accessToken && accessToken.length > 0) {
                options.headers.append('Authorization', `Bearer ${accessToken}`);
            }

            if (options.body && typeof options.body !== 'string' && !isFormData) {
                options.body = JSON.stringify(options.body);
                options.headers.append("Content-Type", "application/json");
            }
        }
    }

    private getHttpHeaders(): HttpHeaders {
        const headers = new HttpHeaders();

        const accessToken = this.authService.getAccessToken();
        if (accessToken && accessToken.length > 0) {
            headers.append('Authorization', `Bearer ${accessToken}`);
        }

        return headers;
    }

    private handleError(error: Response): Observable<any> {
        console.log(error);

        if (this.loggerService) {
            this.loggerService.reportError(BaseHttpService.name, error);
        }

        if (this.store) {
            this.store.dispatch(new AppUiActions.HideLoadingOverlay());
        }

        if (error.status == 401) {
            if (this.store) {
                this.store.dispatch(new AppUiActions.ShowGenericPage("Unauthorized", "Access denied.", true));
            }
            return Observable.throw("Unauthorized.");
        }

        if (error.status == 403) {
            if (this.store) {
                this.store.dispatch(new AppUiActions.ShowGenericPage("Forbidden", "Access denied.", true));
            }
            return Observable.throw("Forbidden.");
        }

        if (error.headers.has("Content-Type") && error.headers.get("Content-Type").indexOf("application/json") > -1) {
            let msg = ErrorMessage.Http_Unknown;
            const errorObj = error.json();
            if (errorObj.Reasons && errorObj.Reasons.length > 0) {
                msg = errorObj.Reasons[0].ErrorMessage;
            }
            return Observable.throw(msg + " Please restart Secure Browser.");
        }

        return Observable.empty();
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/services/base-http.service.ts